import { FETCH_INTERVENTION_FAILURE } from 'modules/interventions/actionTypes';
import * as types from 'modules/selfServices/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsSendingState */

/** @type {IsSendingState} */
export const initialState = false;

const set = () => true;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.SEND_SELF_SERVICE]: set,
  [types.SAVE_INTERVENTION_AND_SEND_SELF_SERVICE]: set,
  [types.SEND_SELF_SERVICE_SUCCESS]: reset,
  [types.SEND_SELF_SERVICE_FAILURE]: reset,
  [FETCH_INTERVENTION_FAILURE]: reset,
});
